





























































































































































































import { Vue, Component, PropSync } from 'vue-property-decorator'

import { convert24HTimeTo12H } from '@/utils'
import { CallDetailsInformation } from '@/types'
import WhatWentWrong from '@/components/WhatWentWrong.vue'

import config from '@/config'

@Component({
  components: {
    WhatWentWrong
  }
})
export default class CallDetails extends Vue {
  @PropSync('formStep')
  private step!: 'Details' | 'Review' | 'Confirmation'

  @PropSync('callDetails')
  private data!: CallDetailsInformation

  private dateMenu = false
  private timeMenu = false

  private onSubmit () {
    this.step = 'Review'
  }

  private get isMagenta () {
    return config.isMagenta
  }

  private get formattedTime () {
    return convert24HTimeTo12H(this.data.time)
  }
}
